import { IMultiOccurrence, IMultiOccurrenceOptions } from '../../../../../core/services/multi-occurrence.service';
import { IFormulaireItemClass } from '../../../../../core/services/formulaire/formulaire-item.service';
import { IFormulaireClass } from '../../../../../core/services/formulaire/formulaire.service';
import { IEcranDetailsResourcesEntite } from '../../../../../core/resources/ecran-details.resource';
import { IMenuClass } from '../../../../../core/services/menu/menu.service';
import { IMenuItemActionClass } from '../../../../../core/services/menu/menu-item-action.service';
import { IMenuItemSelectionClass } from '../../../../../core/services/menu/menu-item-selection.service';
import { IPaginationClass } from '../../../../../core/services/pagination.service';

interface IPageTf0032 {
    multiOccurrenceOptions: IMultiOccurrenceOptions;
    multiOccurrence: IMultiOccurrence;
    valeursEcran: any;
}
/* @ngInject */
export default function Tf0032Controller(Formulaire: IFormulaireClass,
    FormulaireItem: IFormulaireItemClass,
    ecranDetails: IEcranDetailsResourcesEntite,
    Menu: IMenuClass,
    MenuItemAction: IMenuItemActionClass,
    MenuItemSelection: IMenuItemSelectionClass,
    Pagination: IPaginationClass) {
    const vm: IPageTf0032 = this;

    vm.valeursEcran = ecranDetails.valeurs;

    vm.multiOccurrenceOptions = {
        actions: new Menu([
            new MenuItemAction(
                'LBL_BTN_MODIF',
                'BOUMOD',
                () => ({}),
                {
                    iconButton: false,
                    class: 'ex-button-action ex-accent-hue-1-bg ex-accent-hue-2-bg--hover md-raised',
                    formulaireConfirmationAction: {
                        lblTitre: 'LBL_TXT_MODIF',
                        lblConfirm: 'G_LBL_EXECUTER',
                        largeurFormulaire: 40,
                        formulaire: new Formulaire([
                            new FormulaireItem('modindimp', { default: 1 })
                        ], { largeurDefaut: 100 })
                    },
                    successAction: () => { vm.multiOccurrence.fetchDataList() }
                }
            )
        ]),
        fonctions: {
            rechercheCollapsable: false,
            effaceCriteres: true,
            pagination: true
        },
        criteresSuggeres: new Formulaire([
            new FormulaireItem('vaeefatypcri', { largeur: 66.66, default: 'EMP', required: true }),
            new FormulaireItem('anneecri', { 
                largeur: 33.33, 
                required: true, 
                default: vm.valeursEcran.anndef,
                disabled: (data:any) => (data.vaeefatypcri !== 'EMP')
             }),
            new FormulaireItem('urgcleintcri', { disabled: (data:any) => (data.vaeefatypcri !== 'EMP') }),
            new FormulaireItem('strcleintcri', { disabled: (data:any) => (data.vaeefatypcri !== 'EMP') }),
            new FormulaireItem('unocleintrhcri', { disabled: (data:any) => (data.vaeefatypcri !== 'EMP') }),
            new FormulaireItem('cincleintcri'),
            new FormulaireItem('mopcleintcri', { disabled: (data:any) => (data.vaeefatypcri !== 'EMP') }),
            new FormulaireItem('indrelpapcri', { 
                default: 'Tous',
                disabled: (data:any) => (data.vaeefatypcri !== 'EMP')
            })
        ]),
        actionsSelection: new Menu([
            new MenuItemSelection(
                'LBL_SEL_OUI',
                'BOUSELOUI',
                {
                    selection: { nom: 'selection' },
                    fonction: 'BOUSELOUI',
                    successAction: () => { 
                        vm.multiOccurrence.fetchDataList();
                    }
                }
            ),
                new MenuItemSelection(
                    'LBL_SEL_NON',
                    'BOUSELNON',
                    {
                        selection: { nom: 'selection' },
                        fonction: 'BOUSELNON',
                        successAction: () => { 
                            vm.multiOccurrence.fetchDataList();
                        }
                    }
            )    
        ]),
        pagination: new Pagination({
            nombreElementPage: 100,
            nbElementsPossibles: [100, 250, 500]
        }), 
        colonnesVisibles: [
            { nom: 'efacod', largeur: 130 },
            { nom: 'efanom', largeur: 250 },
            { nom: 'efaprn', largeur: 250 },
            { nom: 'efaflgimp', largeur: 120 }
        ]
    };
}
